






















import { Prop, Component, Vue } from "vue-property-decorator";
import { Breadcrumb } from "@/models/file";

@Component({})
export default class VFolderPath extends Vue {
  @Prop({ default: () => [] }) breadcrumbs!: Breadcrumb[];

  last(index: number) {
    return index === this.breadcrumbs.length - 1;
  }

  open(item: Breadcrumb) {
    this.$emit("open", item);
  }

  move(e: DragEvent, folderId: any) {
    if (!e.dataTransfer) return;
    e.dataTransfer.dropEffect = "move";
    const id = e.dataTransfer.getData("id");
    if (!id) return;
    this.$emit("move", id, folderId);
  }
}
